import { makeStyles } from '@material-ui/core';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import React from 'react';


const useStyles = makeStyles(() => {
  return {
    muteBtnControl: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      bottom: '0',
      right: '0',
      position: 'absolute',
      zIndex: 10000,
      height: '22px',
      width: '22px',
      backgroundColor: 'rgba(54, 54, 54, 0.5)',
      border: 'none',
    },
    muteBtn: {
      fontSize: '1.8rem',
      color: '#fff',
    },
  };
});

function MuteButton(props) {
  const {
    isMuted,
    isFeaturedClip,
    onMute,
    showMuteButton,
  } = props;
  const classes = useStyles();

  if (!isFeaturedClip || !showMuteButton) {
    return null;
  }

  const VolumeIcon = isMuted ? VolumeOffIcon : VolumeUpIcon;

  return (
    <button className={classes.muteBtnControl} onClick={onMute}>
      <VolumeIcon className={classes.muteBtn} />
    </button>
  );
}

export default MuteButton;
